import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { BaseService } from "@projects/shared-lib/src/lib/services/base-http.service";
import { UserInfo } from 'src/app/shared/constants/ascend-user-project-info';
import { environment } from "src/environments/environment";
import { PROJECT_STATUS } from "@projects/shared-lib/src/lib/utility/constants";
import { EU_REGION } from "../utility/constants";
import { saveAs } from 'file-saver';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

interface Data {
  projectId: number;
  pinnedStatus: boolean;
}

interface PinnedApiResponse {
  status: number;
  data: Data;
  timestamp: string;
}

@Injectable({
  providedIn: "root",
})
export class ListService {

  BASE_URL='';
  public isExpiredProject :any= new Subject();
  constructor(private http : HttpClient,
    private baseService: BaseService) {
      this.BASE_URL=environment.API_MICROSERVICE_URL.PROJECT;
  }

  getUserProjectInfo(params, selectedIndexTab = 0, BASE_URL=this.BASE_URL) {
    if(selectedIndexTab == 3){
      params = params.append("project_status",PROJECT_STATUS.EXPIRED);
      return this.getExpiredProjectInfo(params, BASE_URL);
    }
    if(selectedIndexTab == 0){
      let approvedParams = new HttpParams();
      let cloningParams = new HttpParams();
      if(params) {
        params.keys().forEach(key => {
          approvedParams = approvedParams.set(key, params.get(key));
          cloningParams = cloningParams.set(key, params.get(key));
        });
      }
      approvedParams = approvedParams.set("project_status", PROJECT_STATUS.APPROVED);
      cloningParams = cloningParams.set("project_status", PROJECT_STATUS.APPROVED_CLONING_IN_PROGRESS);
      return forkJoin([
        this.http.get<UserInfo>(BASE_URL+'/project', {params: approvedParams}),
        this.http.get<UserInfo>(BASE_URL+'/project', {params: cloningParams})
      ]).pipe(
        map(([approvedProjects, cloningProjects]) => {
          const combinedResult = {...approvedProjects};
          if (cloningProjects && cloningProjects.projectInfo) {
            combinedResult.projectInfo = [
              ...(approvedProjects.projectInfo || []),
              ...(cloningProjects.projectInfo || [])
            ];
          }
          return combinedResult;
        })
      );
    } else if(selectedIndexTab == 1) {
      params = params.append("project_status",PROJECT_STATUS.DRAFT);

    } else if(selectedIndexTab == 2) {
      params = params.append("project_status",PROJECT_STATUS.REJECTED);
    } else if(selectedIndexTab == 4){
      params = params.append("project_status",PROJECT_STATUS.PENDING_APPROVAL); 
    }
    return this.http.get<UserInfo>(BASE_URL+'/project',{params});
  }

  getFilteredUsersProject(payload, selectedIndexTab, params, BASE_URL=this.BASE_URL) {
    if(selectedIndexTab == 3){
      params = params.append("project_status",PROJECT_STATUS.EXPIRED);
      payload.project_status = PROJECT_STATUS.EXPIRED;
      return this.getExpiredProjectInfo(params, BASE_URL);
    }
    if(selectedIndexTab == 0){
      const approvedPayload = JSON.parse(JSON.stringify(payload));
      const cloningPayload = JSON.parse(JSON.stringify(payload));
      approvedPayload.project_status = PROJECT_STATUS.APPROVED;
      cloningPayload.project_status = PROJECT_STATUS.APPROVED_CLONING_IN_PROGRESS;
      return forkJoin([
        this.http.post(BASE_URL + `/project/filterProjects`, approvedPayload),
        this.http.post(BASE_URL + `/project/filterProjects`, cloningPayload)
      ]).pipe(
        map(([approvedProjects, cloningProjects]: [any, any]) => {
          const combinedResult = {...approvedProjects};
          combinedResult.projectInfo = [
            ...(approvedProjects.projectInfo || []),
            ...(cloningProjects && cloningProjects.projectInfo ? cloningProjects.projectInfo : [])
          ];
          return combinedResult;
        })
      );
    } else if(selectedIndexTab == 1) {
      payload.project_status = PROJECT_STATUS.DRAFT;
    } else if(selectedIndexTab == 2) {
      payload.project_status = PROJECT_STATUS.REJECTED;
    } else if(selectedIndexTab == 4){
      payload.project_status = PROJECT_STATUS.PENDING_APPROVAL;
    }
    return this.http.post(BASE_URL +`/project/filterProjects`, payload);
  }

  getPinnedProjects(email: String) {
    return this.http.get(this.BASE_URL+`/project/pinnedProjects`);
  }
  
  getPackagePref(package_id: number,function_id: number,feature_id: number, langId,api_base_url ?:string,instance_name ?: string) {
  
    if(instance_name && instance_name === EU_REGION){

      return this.http.get(api_base_url+`/admin/api/v1/package/preferences/${package_id}/${function_id}/${feature_id}?languageId=${langId}`);
    }
    else{
      return this.http.get(environment.API_MICROSERVICE_URL?.ADMIN+`/package/preferences/${package_id}/${function_id}/${feature_id}?languageId=${langId}`);

    }
   }
   getUserPreferences(){
     return this.http.get<any>(`${environment.API_MICROSERVICE_URL?.METHOD}/package/package-detail?statusId=1`).map(res => this.getPckgResponse(res));
   }

   getPckgResponse(res) {
    res?.data?.forEach((item) => {
      item.name = item.package_method_nm;
      item.package_id = item.package_method_id;
      item.project_mode = item.is_project_mode_set ? 'Y' : 'N';
    })
    return res;
   }
 
  // get the project details for the logged in user
  getCurrentUserInfo(userId) {
    return this.http.get(`${environment.API_MICROSERVICE_URL?.USER}/user`);
  }

  /**
   * Security Fix: Removed email from URL query parameter - backend extracts user from JWT token
   */
  getProjectInfo(userId: any) {
    // userId parameter kept for compatibility but not used in URL - backend extracts from JWT
    return this.http.get(
      `${this.BASE_URL}/project?sortBy=date&sortOrder=desc`
    );

  }
  getIsExpiredProject(): Observable<any> {
    return this.isExpiredProject.asObservable();
  }

  setIsExpiredProject(value) {
    this.isExpiredProject.next(value);
  }

  getExpiredProjectInfo(params, BASE_URL = this.BASE_URL) {
    return this.http.get<UserInfo>(BASE_URL+'/project/expired',{params});
  }

  getProjectDetailsByProjectId(projectId) {
    return this.http.get(this.BASE_URL + `/project/` + projectId);
  }

  updatePinnedProject(payload, BASE_URL = this.BASE_URL): Observable<PinnedApiResponse>{
    return this.http.post<PinnedApiResponse>(BASE_URL + `/project/pinProject/update`, payload);
  }

  getRegionSelection(languageId?): any {
    return this.http.get(environment.API_MICROSERVICE_URL?.PROJECT + `/project/region-selection?languageId=${languageId}`)
  }

  getGlobalInstances(languageId?): any {
    return this.http.get(environment.API_MICROSERVICE_URL?.PROJECT + `/project/global-instances?languageId=${languageId}`)
  }

  /**
   * DownloadLatestBanner : used to download the banner document
   */
  downloadLatestBanner = () => {
    return this.baseService.getBlobAsJsonForPdf(
      `tools/latestBanner/preview`,
      environment.API_MICROSERVICE_URL?.ADMIN
    )
    .pipe(
      map(response => {
        const blob = response.body;
        
        if (!blob) {
          throw new Error('Blob is null or undefined');
        }
  
        return blob;
      })
    );
  }

  /**
   * CreateFileNameAndSave : used to create filename and save the file
   */
  createFileNameAndSave = (data) => {
    const type = data.headers.get("content-type"),
      blob = new Blob([data.body], { type });
      
    let filename = data.headers
      .get("content-disposition")
      .split("filename=")[1]
      .split(";")[0];

    filename = filename.replaceAll('"', "");
    saveAs(blob, filename);
  }
}